export enum WindowEnvironmentKind {
    ServiceWorker = 'ServiceWorker',
    Host = 'Host',
    Unknown = 'Unknown',
}
